import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { selectProcessingFilters, StoredFilterDescription } from 'app/redux/processing/reducer';
import { PROCESSING_OPTIONS_LIST } from 'app/utils/PROCESSING_OPTIONS';

export default function useProcessingFiltersListWithDefaults(): StoredFilterDescription[] {
  const intl = useIntl();
  const processingFilters = useSelector(selectProcessingFilters);

  return React.useMemo(() => {
    return [
      ...PROCESSING_OPTIONS_LIST.map((option) => ({
        name: intl.formatMessage({ id: `tools.processing.filter.${option.id}.label` }),
        id: option.id,
        parameters: option.parameters,
      })),
      ...processingFilters,
    ];
  }, [processingFilters, intl]);
}
